import type { z } from 'zod';
import { ServiceIndisponibleError } from '../erreurs';

/**
 * Validates what Tahiti sent. An answer that does not match its schema is an unexpected
 * answer, reported as `ServiceIndisponibleError` (never a raw `ZodError` towards the
 * screens). `quoi` names the call in the message, for the logs.
 */
export function analyser<T>(schema: z.ZodType<T, unknown>, valeur: unknown, quoi: string): T {
  const resultat = schema.safeParse(valeur);
  if (!resultat.success) {
    const detail = resultat.error.issues
      .slice(0, 3)
      .map((issue) => `${issue.path.join('.') || '(root)'}: ${issue.message}`)
      .join('; ');
    throw new ServiceIndisponibleError(`Unexpected answer from Tahiti for ${quoi} (${detail})`);
  }
  return resultat.data;
}
